import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { checkLoginStatus } from '../actions/user';
import App from '../components/App';

interface MapDispatchToProps {
  checkLoginStatus: () => (dispatch: Dispatch<AuthenticationAction>, getState: () => RootReducerState) => Promise<boolean>
}

const mapDispatchToProps = (dispatch: Dispatch<AuthenticationAction>): MapDispatchToProps => bindActionCreators({
  checkLoginStatus
}, dispatch);

export default connect(undefined, mapDispatchToProps)(App);
